export const SITE_ORIGIN = "https://seaclaysprayfoam.com";
export const SOCIAL_IMAGE = `${SITE_ORIGIN}/__l5e/assets-v1/e87b10d0-6289-4d2b-b4f3-d928399b5977/image.png`;

export const SITE_TITLE = "SeaClay Roofing & Spray Foam Insulation | Prairie Farm, WI";
export const SITE_DESCRIPTION =
  "Spray foam, blown & batting insulation plus roofing in Northwest Wisconsin. 25+ years of expertise. Meet or beat any spray foam bid. Call (715) 418-3887.";

const BRAND = "SeaClay Roofing & Spray Foam Insulation";
const LOCATION = "Prairie Farm, WI";
const TITLE_MAX = 60;
const DESC_MAX = 155;

export const SITEMAP_PATHS = [
  "/",
  "/services",
  "/services/new-construction-spray-foam",
  "/services/spray-foam-insulation",
  "/services/blown-insulation",
  "/services/batting-insulation",
  "/services/spray-foam-roofing",
  "/services/metal-roof-restoration",
  "/about",
  "/reviews",
  "/faq",
  "/contact",
] as const;

function clip(text: string, max: number) {
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).trimEnd()}…`;
}

/** Prefer the full brand pattern; shorten until the title fits 60 characters. */
export function pageTitle(page: string) {
  const candidates = [
    `${page} | ${BRAND} | ${LOCATION}`,
    `${page} | SeaClay Roofing | ${LOCATION}`,
    `${page} | SeaClay | ${LOCATION}`,
    `${page} | ${LOCATION}`,
  ];
  return (
    candidates.find((title) => title.length <= TITLE_MAX) ??
    clip(`${page} | ${LOCATION}`, TITLE_MAX)
  );
}

export function seo({
  title,
  description,
  path,
  home = false,
}: {
  title: string;
  description: string;
  path: string;
  home?: boolean;
}) {
  const full = home ? clip(title, TITLE_MAX) : pageTitle(title);
  const desc = clip(description, DESC_MAX);
  const canonical = `${SITE_ORIGIN}${path === "/" ? "/" : path}`;

  return {
    meta: [
      { title: full },
      { name: "description", content: desc },
      { property: "og:title", content: full },
      { property: "og:description", content: desc },
      { property: "og:url", content: canonical },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_US" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: SOCIAL_IMAGE },
      { name: "twitter:image", content: SOCIAL_IMAGE },
      { name: "twitter:title", content: full },
      { name: "twitter:description", content: desc },
    ],
    links: [{ rel: "canonical", href: canonical }],
  };
}
